<template>
  <div>
    <div class="mb-2">
      <div
        class="header-purple d-flex justify-content-between align-items-center"
      >
        <div>
          <p class="mb-0">
            <strong>ข้อมูลทั่วไป </strong>
            <span class="text-purple1 f-size-14"> *{{ getProductRemark }}</span>
          </p>
        </div>
        <div>
          <p class="mb-0 text-gray-1">อัพเดทล่าสุด : {{ updatedDate }}</p>
        </div>
      </div>
      <div class="p-4 bg-white">
        <b-container class="p-0">
          <b-row class="no-gutters">
            <b-col>
              <div
                v-for="(item, index) in form.product.translationList"
                v-bind:key="index"
              >
                <div
                  v-bind:class="[
                    languageActive == item.languageId ? '' : 'd-none',
                  ]"
                >
                  <InputText
                    textFloat="ชื่อสินค้า"
                    v-model="item.name"
                    @onKeyup="setMeta(item.name, index)"
                    isRequired
                    class="mr-1"
                    :disabled="form.product.flagSyncExternalSync == 1"
                    placeholder="ชื่อสินค้า"
                    type="text"
                    :isValidate="
                      $v.form.product.translationList.$each.$iter[index].name
                        .$error
                    "
                    :v="$v.form.product.translationList.$each.$iter[index].name"
                  />
                </div>
              </div>
            </b-col>
            <b-col>
              <!-- <InputSelect
                title="คอลเลคชัน"
                name="collection"
                :options="collectionList"
                valueField="id"
                textField="name"
                :isValidate="$v.form.product.collection.$error"
                :v="$v.form.product.collection"
                isRequired
                :disabled="form.product.flagSyncExternalSync == 1"
                v-model="form.product.collection"
                @onDataChange="(val) => (form.product.collection = val)"
              /> -->
              <InputText
                textFloat="คอลเลคชัน"
                v-model="form.product.collection"
                isRequired
                class="mr-1"
                :disabled="form.product.flagSyncExternalSync == 1"
                placeholder="คอลเลคชัน"
                type="text"
                :isValidate="$v.form.product.collection.$error"
                :v="$v.form.product.collection"
              />
            </b-col>
          </b-row>
          <div class="mb-3">
            <p class="mb-1">
              <strong>หมวดหมู่ <span class="text-danger">*</span></strong>
            </p>
            <div class="">
              <CategoryHierarchy
                v-if="categories.length > 0"
                :categories="categories"
                :dataList="form.product.selectCategory"
                @onDataChange="onDataChangeCategory"
                :v="$v.form.product.selectCategory"
                :isDisplay="form.product.flagSyncExternalSync == 1"
              />
            </div>
          </div>
          <b-row class="no-gutters">
            <b-col>
              <InputText
                textFloat="Parent SKU"
                v-model="form.product.sku"
                isRequired
                class="mr-1"
                :disabled="form.product.flagSyncExternalSync == 1"
                placeholder="SKU"
                type="text"
                :isValidate="$v.form.product.sku.$error"
                :v="$v.form.product.sku"
              />
            </b-col>
            <b-col>
              <InputText
                textFloat="Barcode"
                v-model="form.product.barcode"
                isRequired
                class="ml-1"
                :disabled="form.product.flagSyncExternalSync == 1"
                placeholder="barcode"
                type="text"
                :isValidate="$v.form.product.barcode.$error"
                :v="$v.form.product.barcode"
              />
            </b-col>
          </b-row>
          <div>
            <div
              v-for="(item, index) in form.product.translationList"
              v-bind:key="index"
            >
              <div
                v-bind:class="[
                  languageActive == item.languageId ? '' : 'd-none',
                ]"
              >
                <TextEditor
                  textFloat="รายละเอียดสินค้า"
                  v-model="item.description"
                  placeholder="รายละเอียดสินค้า"
                  :rows="8"
                  isRequired
                  :name="'prodetail-description'"
                  @onDataChange="(val) => (item.description = val)"
                  :v="
                    $v.form.product.translationList.$each.$iter[index]
                      .description
                  "
                  :isDisplay="form.product.flagSyncExternalSync == 1"
                />
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </div>
    <div class="mt-2">
      <div class="header-purple">
        <div>
          <p class="mb-0">
            <strong>ประเภทสินค้า</strong>
            <span class="text-purple1 f-size-14">
              * {{ getProductRemark }}</span
            >
          </p>
        </div>
      </div>
      <div class="p-4 bg-white">
        <div>
          <p>
            <strong>ประเภทสินค้า <span class="text-danger">*</span></strong>
          </p>
        </div>
        <b-row class="mb-4">
          <b-col md="6" class="mb-1 mb-sm-0">
            <b-row>
              <b-col>
                <b-form-radio
                  name="some-type"
                  :value="1"
                  v-model="form.product.productTypeId"
                  :disabled="form.product.id > 0"
                  @change="handleProducTypeChange"
                  >สินค้าไม่มีตัวเลือก</b-form-radio
                >
              </b-col>
              <b-col>
                <b-form-radio
                  name="some-type"
                  :value="2"
                  v-model="form.product.productTypeId"
                  :disabled="true"
                  @change="handleProducTypeChange"
                  >สินค้าตัวเลือก
                </b-form-radio>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div v-if="form.product.productTypeId === 1">
          <div class="sku-section my-4 pt-3 pb-4">
            <b-container class="p-0">
              <b-row class="no-gutters">
                <b-col>
                  <InputText
                    textFloat="ราคาป้าย"
                    v-model="form.product.price"
                    isRequired
                    class="mr-1"
                    :disabled="form.product.flagSyncExternalSync == 1"
                    placeholder="ราคาป้าย"
                    type="number"
                    :isValidate="$v.form.product.price.$error"
                    :v="$v.form.product.price"
                  />
                </b-col>
                <b-col>
                  <InputText
                    textFloat="Minimum Stock"
                    v-model="form.product.minimunStockAlert"
                    isRequired
                    class="mr-1"
                    :disabled="form.product.flagSyncExternalSync == 1"
                    placeholder="Minimum Stock"
                    type="number"
                    :isValidate="$v.form.product.minimunStockAlert.$error"
                    :v="$v.form.product.minimunStockAlert"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="isAdvancePrice"
                    name="check-button"
                    @change="onIsAdvancePriceChange"
                  >
                    ราคาขาย
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <template v-if="isAdvancePrice && form.product.advancePrice">
                <b-row class="mt-2">
                  <b-col cols="6">
                    <InputText
                      textFloat="ราคาขาย"
                      v-model="form.product.advancePrice.priceAfterDiscount"
                      isRequired
                      class="mr-1"
                      :disabled="form.product.flagSyncExternalSync == 1"
                      placeholder="ราคาขาย"
                      type="number"
                      :isValidate="
                        $v.form.product.advancePrice.priceAfterDiscount.$error
                      "
                      :v="$v.form.product.advancePrice.priceAfterDiscount"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label class="mb-1 font-weight-bold"
                      >วันที่เริ่มต้น
                      <span class="pl-2 text-red">*</span></label
                    >
                    <div class="input-container mr-2">
                      <datetime
                        :input-style="styleDatetime"
                        v-model="form.product.advancePrice.startDate"
                        placeholder="วว / ดด / ปป"
                        ref="startDate"
                      >
                      </datetime>
                      <div
                        class="icon-container text-right"
                        @click="$refs.startDate.isOpen = true"
                      >
                        <font-awesome-icon
                          icon="calendar-alt"
                          color="#B41BB4"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col>
                    <label class="mb-1 font-weight-bold"
                      >วันที่สิ้นสุด <span class="pl-2 text-red">*</span></label
                    >
                    <div class="input-container mr-2">
                      <datetime
                        :input-style="styleDatetime"
                        v-model="form.product.advancePrice.endDate"
                        placeholder="วว / ดด / ปป"
                        ref="endDate"
                      >
                      </datetime>
                      <div
                        class="icon-container text-right"
                        @click="$refs.endDate.isOpen = true"
                      >
                        <font-awesome-icon
                          icon="calendar-alt"
                          color="#B41BB4"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </template>
            </b-container>
          </div>
        </div>

        <div v-else-if="form.product.productTypeId == 2">
          <div class="sku-section mb-4 pb-4">
            <div class="mt-4">
              <p>ราคาและสต็อกสินค้า</p>
            </div>
            <CombinationTable
              :advancePriceData="advancePrice"
              :dataObject="form.product.children"
              :attributes="form.product.attributes"
              :v="$v.form.product.children.attributeOption"
              :isDisable="true"
              :isDisableSKU="true"
              :isDisableBarcode="true"
              :isDisablePrice="true"
              :isDisableAdvancePrice="true"
            />
          </div>
        </div>
        <div
          class="py-3"
          v-if="
            form.product.flagSyncExternalSync == 1 &&
            form.product.externalAttributes.length > 0
          "
        >
          <b-row class="no-gutters text-center">
            <b-col
              class="propeties-container bg-purple2 border-right p-2"
              cols="4"
            >
              <strong>ชื่อคุณลักษณะ</strong>
            </b-col>
            <b-col class="propeties-container bg-purple2 p-2" cols="8">
              <strong>คำคุณลักษณะ</strong>
            </b-col>

            <b-col
              v-for="(attr, index) in form.product.externalAttributes"
              :key="'externalAttributesfield' + index"
              class="propeties-container border-right p-2"
              cols="4"
            >
              {{ attr.name }}
            </b-col>
            <b-col
              v-for="(attr, index) in form.product.externalAttributes"
              :key="'externalAttributesvalue' + index"
              class="propeties-container p-2"
              cols="8"
            >
              {{ attr.value }}
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <div class="header-purple">
        <div>
          <p class="mb-0">
            <strong>การจัดส่ง</strong>
            <span class="text-purple1 f-size-14"> *{{ getProductRemark }}</span>
          </p>
        </div>
      </div>
      <div class="p-4 bg-white">
        <b-container class="p-0">
          <b-row class="no-gutters">
            <b-col md="3">
              <InputText
                textFloat="น้ำหนักสินค้า (กรัม)"
                v-model="form.product.weight"
                isRequired
                class="mr-1"
                :disabled="form.product.flagSyncExternalSync == 1"
                placeholder="น้ำหนักสินค้า"
                type="number"
                :isValidate="$v.form.product.weight.$error"
                :v="$v.form.product.weight"
              />
            </b-col>
            <b-col md="3">
              <InputText
                textFloat="ความยาวสินค้า (ซม.)"
                v-model="form.product.length"
                isRequired
                class="mr-1"
                :disabled="form.product.flagSyncExternalSync == 1"
                placeholder="ความยาวสินค้า"
                type="number"
                :isValidate="$v.form.product.length.$error"
                :v="$v.form.product.length"
              />
            </b-col>
            <b-col md="3">
              <InputText
                textFloat="ความกว้างสินค้า (ซม.)"
                v-model="form.product.width"
                isRequired
                class="mr-1"
                :disabled="form.product.flagSyncExternalSync == 1"
                placeholder="ความกว้างสินค้า"
                type="number"
                :isValidate="$v.form.product.width.$error"
                :v="$v.form.product.width"
              />
            </b-col>
            <b-col md="3">
              <InputText
                textFloat="ความสูงสินค้า (ซม.)"
                v-model="form.product.height"
                isRequired
                class="ml-1"
                :disabled="form.product.flagSyncExternalSync == 1"
                placeholder="ความสูงสินค้า"
                type="number"
                :isValidate="$v.form.product.height.$error"
                :v="$v.form.product.height"
              />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <div class="mt-2">
      <div class="p-4 bg-white">
        <b-container class="p-0">
          <b-row class="no-gutters">
            <b-col sm="6" class="d-flex align-items-center">
              <p class="mb-0 mr-4">
                <strong>การแสดงผล <span class="text-danger">*</span></strong>
              </p>
              <b-form-checkbox
                v-model="form.product.enabled"
                name="display-button"
                size="lg"
                switch
              />
              <span class="ml-2">
                {{ form.product.enabled ? "เปิด" : "ปิด" }}
              </span>
            </b-col>
            <!-- <b-col
              sm="6"
              v-if="productType === 1"
              class="d-flex align-items-center mt-4 mt-sm-0"
            >
              <p class="mb-0 mr-4">
                <strong
                  >ซิงค์เข้าระบบ SAP <span class="text-danger">*</span></strong
                >
              </p>
              <b-form-checkbox
                v-model="form.product.flagSyncSAP"
                name="syncsap-button"
                size="lg"
                switch
              />
              <span class="ml-2">
                {{ form.product.flagSyncSAP ? "เปิด" : "ปิด" }}
              </span>
            </b-col> -->
          </b-row>
        </b-container>
      </div>
    </div>
    <div class="mt-2">
      <div class="p-2 bg-white">
        <b-container class="p-0">
          <b-row class="no-gutters">
            <b-col md="6" class="d-flex">
              <b-button
                class="mr-2 btn-main-2"
                v-if="
                  form.product.flagSyncExternalSync !== 1 &&
                  form.product.id !== 0
                "
                @click="openModalDelete(form.product.translationList[0].name)"
                >ลบ</b-button
              >
              <b-button class="btn-main-3" @click="$emit('handleRoute')"
                >ยกเลิก</b-button
              >
            </b-col>
            <b-col md="6" class="d-flex justify-content-md-end mt-3 mt-md-0">
              <!-- <b-button
                @click="checkForm(0)"
                class="btn-main"
                v-if="form.product.flagSyncExternalSync !== 1"
                :disabled="isDisabled"
                >บันทึกแบบร่าง</b-button
              > -->
              <b-button
                class="ml-2 btn-main"
                @click="checkForm(1)"
                v-if="form.product.flagSyncExternalSync !== 1"
                :disabled="isDisabled"
                >บันทึก</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ"
      :text="modalMessage"
      btnConfirm="ลบ"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirm"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";
import TextEditor from "@/components/inputs/TextEditor";
import InputCheckBox from "@/components/inputs/InputCheckBox";
import CategoryHierarchy from "../../../../../components/categoryHierarchy/CategoryHierarchy.vue";
import CombinationTable from "./CombinationListSection";
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  alphaNum,
} from "vuelidate/lib/validators";
import category from "../../../../../components/categoryHierarchy/category.json";
import ConfigOptionsSection from "./ConfigOptionsSection.vue";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import * as moment from "moment/moment";

export default {
  name: "ProductDetailPanel",
  components: {
    InputText,
    CategoryHierarchy,
    InputTextArea,
    TextEditor,
    InputCheckBox,
    CombinationTable,
    ConfigOptionsSection,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
    ModalAlertConfirm,
    InputSelect,
  },
  data: function () {
    return {
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      id: 0,
      updatedDate: new Date().toDateString(),
      productType: 1,
      languageActive: 1,
      categoriesJson: category,
      isEdit: false,
      categories: {},
      modalMessage: "",
      isDisabled: false,
      isAdvancePrice: false,
      // collectionList: [{ id: null, name: "เลือกคอลเลคชัน" }],
      requestDeleteProduct: {
        productId: 0,
      },
      advancePrice: {
        price: 0.0,
        id: null,
        productId: null,
        priceAfterDiscount: 0.0,
        startDate: "",
        endDate: "",
        enabled: false,
        isError: "",
      },
      dataCategoryHierarchy: {
        categoryList: [],
        isLast: false,
        selectId: 0,
      },
      form: {
        product: {
          advancePrice: {
            price: 0.0,
            id: 0,
            productId: 0,
            priceAfterDiscount: 0.0,
            startDate: "",
            endDate: "",
            enabled: false,
            isError: "",
          },
          id: 0,
          sortOrder: 0,
          price: 0.0,
          rawPrice: 0.0,
          straightPrice: 0.0,
          enabled: false,
          display: false,
          sku: null,
          parentSku: null,
          barcode: null,
          imageUrl: null,
          productImage: [],
          productImageRemove: null,
          productTypeId: 1,
          productType: null,
          productionOption: 1,
          urlKey: null,
          weight: 0.0,
          width: 0.0,
          length: 0.0,
          height: 0.0,
          quantity: 0,
          startDateDisplay: null,
          endDateDisplay: null,
          mainLanguageId: 1,
          isSameLanguage: true,
          syncSap: false,
          tagId: [],
          translationList: [
            {
              languageId: 1,
              name: null,
              shortDescription: null,
              description: null,
              metaTitle: null,
              metaKeyword: null,
              metaDescription: null,
              howToUse: null,
              ingredient: null,
            },
            {
              languageId: 2,
              name: null,
              shortDescription: null,
              description: null,
              metaTitle: null,
              metaKeyword: null,
              metaDescription: null,
              howToUse: null,
              ingredient: null,
            },
          ],
          selectCategory: [],
          brandId: this.$route.query.brandId,
          gp: 0.0,
          sellerId: 0,
          isPublish: false,
          attributes: [],
          children: {},
          minimunStockAlert: 0,
        },
      },
      externalAttributesField: [],
    };
  },
  validations: {
    form: {
      product: {
        price: { required },
        sku: { required },
        urlKey: { required },
        selectCategory: { required },
        productImage: {},
        barcode: { required },
        collection: { required },
        advancePrice: {
          priceAfterDiscount: {
            required: requiredIf(function () {
              return this.isAdvancePrice;
            }),
          },
          startDate: {
            required: requiredIf(function () {
              return this.isAdvancePrice;
            }),
          },
          endDate: {
            required: requiredIf(function () {
              return this.isAdvancePrice;
            }),
          },
        },
        minimunStockAlert: { required },
        weight: { required },
        length: { required },
        width: { required },
        height: { required },
        children: {
          attributeOption: {
            $each: {
              product: {
                price: {},
                advancePrice: {},
                sku: {},
                barcode: {},
                weight: {},
                straightPrice: {},
                rawPrice: {},
                quantity: {},
                gp: {},
                translationList: {
                  $each: {
                    name: {},
                  },
                },
              },
              attribute: {
                attributeOption: {
                  $each: {
                    product: {
                      price: {},
                      advancePrice: {
                        priceAfterDiscount: {},
                      },
                      sku: {},
                      barcode: {},
                      weight: {},
                      straightPrice: {},
                      rawPrice: {},
                      translationList: {
                        $each: {
                          name: {},
                        },
                      },
                    },
                    attribute: {
                      attributeOption: {
                        $each: {
                          product: {
                            price: {},
                            advancePrice: {
                              priceAfterDiscount: {},
                            },
                            sku: {},
                            barcode: {},
                            weight: {},
                            straightPrice: {},
                            rawPrice: {},
                            translationList: {
                              $each: {
                                name: {},
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        translationList: {
          $each: {
            name: { required },
            description: { required },
            shortDescription: {},
          },
        },
      },
    },
  },
  created: async function () {},
  mounted: async function () {
    this.$refs.modalLoading.show();
    if (this.$route.params.id) {
      this.form.product.id = parseInt(this.$route.params.id);
    }
    // await this.getProductCollection();
    await this.getProductDetail();
    await this.getCategories();
  },
  methods: {
    onIsAdvancePriceChange(val) {
      if (val) {
        this.form.product.advancePrice = {
          price: 0.0,
          id: 0,
          productId: 0,
          priceAfterDiscount: 0.0,
          startDate: moment().format(),
          endDate: moment().format(),
          enabled: false,
          isError: "",
        };
      } else {
        this.form.product.advancePrice = null;
      }
    },
    // getProductCollection: async function () {
    //   await this.axios.get(`${this.$baseUrl}/product/config`).then((data) => {
    //     let collectionName = data.detail.collection.map((el, index) => {
    //       return { id: el, name: el };
    //     });
    //     this.collectionList = this.collectionList.concat(collectionName);
    //     this.form.product.collection = this.collectionList[0];
    //   });
    // },
    confirmDelete: async function () {
      this.$refs.isModalAlertConfirm.hide();
      this.$refs.modalLoading.show();
      this.axios
        .delete(
          `${this.$baseUrl}/product/removeProductDetail/${this.requestDeleteProduct.productId}`
        )
        .then((resData) => {
          this.modalMessage = resData.message;
          if (resData.result == 1) {
            this.$refs.modalLoading.hide();
            setTimeout(() => {
              this.$emit("handleRoute");
            }, 3000);
          } else {
            this.$refs.modalAlertError.show();
          }
        });
    },
    openModalDelete(name) {
      this.requestDeleteProduct.productId = this.form.product.id;
      this.modalMessage = `คุณต้องการลบ ` + name + ` ใช่ หรือ ไม่?`;
      this.$refs.isModalAlertConfirm.show();
    },
    getProductTypeFlag() {
      return true;
    },
    async hadleModalAlertClose() {
      this.$refs.modalAlert.hide();
      if (parseInt(this.$route.params.id) != 0) {
        this.$v.form.$reset();
        await this.getProductDetail();
        await this.getCategories();
        // await this.getProductCollection();
      } else {
        this.$router.push({
          name: "รายละเอียดสินค้า",
          params: { id: this.id },
          query: { tab: 2 },
        });
      }
    },
    handleProducTypeChange(value) {
      if (!this.form.product.attributes) {
        this.form.product.attributes = [];
      }
      if (!this.form.product.children) {
        this.form.product.children = { attributeOption: [] };
        this.form.product.productAttributeImage = [];
      }
      this.form.product.productTypeId = value;
    },
    getProductDetail: async function () {
      await this.axios
        .get(`${this.$baseUrl}/product/ProductDetail/${this.form.product.id}`)
        .then((data) => {
          this.form.product = data.detail.product;
          if (this.form.product.id == 0) {
            this.form.product.productTypeId = 1;
            this.form.product.minimunStockAlert = 0;
          }

          if (data.detail.product.advancePrice) {
            if (data.detail.product.advancePrice.priceAfterDiscount == 0) {
              this.form.product.advancePrice = null;
              this.isAdvancePrice = false;
            } else {
              this.isAdvancePrice = true;
            }
          } else {
            this.isAdvancePrice = false;
          }

          if (this.form.product.flagSyncExternalSync === 1) {
            this.$emit("onSetIsDisplaySaleChanelTab", true);
          } else {
            this.$emit("onSetIsDisplaySaleChanelTab", false);
          }
          this.$emit("onSetProductType", this.form.product.productTypeId);
          setTimeout(() => {
            this.$refs.modalLoading.hide();
          }, 1000);
        });
    },
    getCategories: async function () {
      await this.axios
        .get(`${this.$baseUrl}/category/categoryHierarchy`)
        .then((cat) => {
          if (cat.result == 1) {
            this.categories = cat.detail;
          }
        });
    },
    setEditFlag(flag) {
      this.isEdit = true;
    },
    setProductChildren(children) {
      this.form.product.children = children;
    },
    setMeta: function (name, index) {
      this.isEdit = true;
      this.form.product.translationList[index].metaTitle = name;
      this.form.product.translationList[index].metaKeyword = name;
      this.form.product.translationList[index].metaDescription = name;

      // Set second tranlstion list = first
      this.form.product.translationList[index + 1].metaTitle = name;
      this.form.product.translationList[index + 1].metaKeyword = name;
      this.form.product.translationList[index + 1].metaDescription = name;
      this.form.product.translationList[index + 1].name = name;
      this.form.product.translationList[index + 1].description =
        this.form.product.translationList[index].description;
      this.form.product.translationList[index + 1].shortDescription =
        this.form.product.translationList[index].shortDescription;
      this.form.product.urlKey = name.replace(/ /g, "-").replace(/\//g, "");
      this.form.product.barcode =
        name.replace(/ /g, "-").replace(/\//g, "") + "-00001-barcode";
    },

    onDataChangeCategory(list) {
      if (this.form.product.flagSyncExternalSync !== 1) {
        this.dataCategoryHierarchy = { ...list };
        this.form.product.selectCategory = [...list.categoryIdList];
      }
    },

    checkForm: async function (flag) {
      this.flag = flag;
      if (this.form.product.flagSyncExternalSync == 1) {
        this.onSubmitSapProduct();
      } else {
        this.form.product.isPublish = flag == 1 ? true : false;

        this.onSubmitNonSapProduct();
      }
    },

    onSubmitSapProduct() {
      this.$refs.modalLoading.show();
      setTimeout(() => {
        this.$refs.modalLoading.hide();
        this.$router.push(`/product?brandID=${this.$route.params.brandID}`);
      }, 2000);
    },
    onSetSameLanguage(translationList) {
      this.form.product.translationList[1].metaTitle = translationList.name;
      this.form.product.translationList[1].metaKeyword = translationList.name;
      this.form.product.translationList[1].metaDescription =
        translationList.name;
      this.form.product.translationList[1].name = translationList.name;
      this.form.product.translationList[1].description =
        translationList.description;
      this.form.product.translationList[1].shortDescription =
        translationList.shortDescription;
    },
    onSubmitNonSapProduct: async function () {
      let catLength = this.form.product.selectCategory.length;
      this.onSetSameLanguage(this.form.product.translationList[0]);
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        if (this.dataCategoryHierarchy.isLast != true) {
          this.errorText = "กรุณาเลือกหมวดหมู่ให้ครบทุกระดับ";
          window.scrollTo(0, 150);
        }

        this.$nextTick(() => {
          if (document.querySelector(".input-custom.error")) {
            let domRect = document
              .querySelector(".input-custom.error")
              .getBoundingClientRect();

            window.scrollTo(
              domRect.left + document.documentElement.scrollLeft,
              domRect.top + document.documentElement.scrollTop - 150
            );
          } else if (document.querySelector(".select-custom.error")) {
            let domRect2 = document
              .querySelector(".select-custom.error")
              .getBoundingClientRect();
            console.log(domRect2);
            window.scrollTo(
              domRect2.left + document.documentElement.scrollLeft,
              domRect2.top + document.documentElement.scrollTop - 150
            );
          } else {
            return;
          }
        });

        return;
      }

      if (catLength > 0) {
        if (this.dataCategoryHierarchy.isLast != true) {
          window.scrollTo(0, 150);
          this.errorText = "Please select all level of sub category";
          this.error = true;
          return;
        } else {
          this.$refs.modalLoading.show();
          await this.axios
            .post(`${this.$baseUrl}/product/productDetail/Save`, this.form)
            .then((data) => {
              this.isDisabled = false;
              if (data.result == 1) {
                this.id = data.detail.productId;
                this.modalMessage = "สำเร็จ";
                this.$refs.modalLoading.hide();
                this.$refs.modalAlert.show();
              } else {
                this.modalMessage = data.detail[0];
                this.$refs.modalLoading.hide();
                this.$refs.modalAlertError.show();
              }
            });
        }
      }
    },
  },
  computed: {
    getProductRemark: function () {
      const remark =
        this.form.product.flagSyncExternalSync === 1
          ? " ข้อมูลจากระบบ SAP (ไม่สามารถแก้ไขได้)"
          : " รายการสินค้าสร้างใหม่จากระบบ(Non-SAP) จะไม่เชื่อมขึ้นระบบ SAP";
      return remark;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-purple {
  padding: 1rem 1.5rem;
  background: #e0e1f4;
}

.sku-section {
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
}

.group-container {
  border: 1px solid #ebebeb;
  padding: 0.5rem;
  border-radius: 6px;
}

.propeties-container {
  border-bottom: 1px solid #ebebeb;
}

.border-right {
  border-right: 1px solid #ebebeb;
}

::v-deep .btn-select {
  padding: 10px 10px !important;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}

.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.text-red {
  color: #e55353 !important;
}
</style>
